import { UpdateTreatmentPlanningProperties } from '../../../redux/API/ClientAPIHelpers/soapNoteProperties';

export enum ACTIONS {
	setState = 'setState',
	setDate = 'setDate',
	setEndTime = 'setEndTime',
	setStartTime = 'setStartTime',
	setLocationId = 'setLocationId',
	setClientTelehealthLocationId = 'setClientTelehealthLocationId',
	setUserTelehealthLocationId = 'setUserTelehealthLocationId',
	setSessionId = 'setSessionId',
	setSignature = 'setSignature',
	setSubmit = 'setSubmit',
	setParticipants = 'setParticipants',
	setParticipantsOther = 'setParticipantsOther',
	setMasteredGoalsAndObjectives = 'setMasteredGoalsAndObjectives',
	setNewGoalsAndObjectives = 'setNewGoalsAndObjectives',
	setTreatmentUpdateResponses = 'setTreatmentUpdateResponses',
	setTreatmentUpdateOther = 'setTreatmentUpdateOther',
	setAnalysisOfGoals = 'setAnalysisOfGoals',
	setGoalUpdates = 'setGoalUpdates',
	setCoordinationAndMaterialsPrepped = 'setCoordinationAndMaterialsPrepped',
	setDescriptionOfSession = 'setDescriptionOfSession',
}

export interface ActionProperties {
	payload: any;

	type: keyof typeof ACTIONS;
}

export const initialTreatmentPlaningState: UpdateTreatmentPlanningProperties = {
	date: '',
	startTime: '',
	endTime: '',
	locationId: null,
	sessionId: '',
	signature: '',
	submit: false,
	participantResponses: [],
	analysisOfGoals: '',
	coordinationAndMaterialsPrepped: '',
	descriptionOfSession: '',
	goalUpdates: '',
	masteredGoalsAndObjectives: '',
	newGoalsAndObjectives: '',
	treatmentUpdateResponses: [],
	forcedOperation: false,
	clientTelehealthLocationId: '',
	userTelehealthLocationId: '',
	clientId: '',
	reportId: '',
	sessionSummary: '',
	treatmentPlanningParticipantOther: '',
	treatmentUpdateOther: '',
};

export const treatmentPlaningReducer = (
	state: UpdateTreatmentPlanningProperties,
	action: ActionProperties,
): UpdateTreatmentPlanningProperties => {
	const { type, payload } = action;

	switch (type) {
		case ACTIONS.setState:
			return {
				...state,
				...payload,
			};
		case ACTIONS.setParticipants:
			return {
				...state,
				participantResponses: payload,
			};
		case ACTIONS.setLocationId:
			return {
				...state,
				locationId: payload,
			};
		case ACTIONS.setMasteredGoalsAndObjectives:
			return {
				...state,
				masteredGoalsAndObjectives: payload,
			};
		case ACTIONS.setNewGoalsAndObjectives:
			return {
				...state,
				newGoalsAndObjectives: payload,
			};
		case ACTIONS.setTreatmentUpdateResponses:
			return {
				...state,
				treatmentUpdateResponses: payload,
			};
		case ACTIONS.setAnalysisOfGoals:
			return {
				...state,
				analysisOfGoals: payload,
			};
		case ACTIONS.setGoalUpdates:
			return {
				...state,
				goalUpdates: payload,
			};
		case ACTIONS.setCoordinationAndMaterialsPrepped:
			return {
				...state,
				coordinationAndMaterialsPrepped: payload,
			};
		case ACTIONS.setDescriptionOfSession:
			return {
				...state,
				descriptionOfSession: payload,
			};
		case ACTIONS.setSignature:
			return {
				...state,
				signature: payload,
			};
		case ACTIONS.setClientTelehealthLocationId:
			return {
				...state,
				clientTelehealthLocationId: payload,
			};
		case ACTIONS.setUserTelehealthLocationId:
			return {
				...state,
				userTelehealthLocationId: payload,
			};
		case ACTIONS.setParticipantsOther:
			return {
				...state,
				treatmentPlanningParticipantOther: payload,
			};
		case ACTIONS.setTreatmentUpdateOther:
			return {
				...state,
				treatmentUpdateOther: payload,
			};
		default:
			return state;
	}
};

export enum ERRORS {
	LocationId = 'LocationId',
	SessionId = 'SessionId',
	Signature = 'Signature',
	ParticipantResponses = 'ParticipantResponses',
	MasteredGoalsAndObjectives = 'MasteredGoalsAndObjectives',
	NewGoalsAndObjectives = 'NewGoalsAndObjectives',
	TreatmentUpdateResponses = 'TreatmentUpdateResponses',
	AnalysisOfGoals = 'AnalysisOfGoals',
	GoalUpdates = 'GoalUpdates',
	CoordinationAndMaterialsPrepped = 'CoordinationAndMaterialsPrepped',
	DescriptionOfSession = 'DescriptionOfSession',
	TreatmentPlanningParticipantOther = 'TreatmentPlanningParticipantOther',
	TreatmentUpdateOther = 'TreatmentUpdateOther',
}

interface TreatmentPlaningErrorStateProperties {
	AnalysisOfGoals: boolean;
	CoordinationAndMaterialsPrepped: boolean;
	DescriptionOfSession: boolean;
	GoalUpdates: boolean;

	LocationId: boolean;
	MasteredGoalsAndObjectives: boolean;
	NewGoalsAndObjectives: boolean;
	ParticipantResponses: boolean;
	SessionId: boolean;
	Signature: boolean;
	TreatmentPlanningParticipantOther: boolean;
	TreatmentUpdateOther: boolean;
	TreatmentUpdateResponses: boolean;
}

export const initialTreatmentPlaningErrorState: TreatmentPlaningErrorStateProperties = {
	LocationId: false,
	SessionId: false,
	Signature: false,
	ParticipantResponses: false,
	MasteredGoalsAndObjectives: false,
	NewGoalsAndObjectives: false,
	TreatmentUpdateResponses: false,
	AnalysisOfGoals: false,
	GoalUpdates: false,
	CoordinationAndMaterialsPrepped: false,
	DescriptionOfSession: false,
	TreatmentPlanningParticipantOther: false,
	TreatmentUpdateOther: false,
};

interface ErrorActionProperties {
	payload: any;

	type: keyof typeof ERRORS;
}

export const treatmentPlaningErrorReducer = (
	state: TreatmentPlaningErrorStateProperties,
	action: ErrorActionProperties,
) => {
	const { payload, type } = action;

	switch (type) {
		case ERRORS[type]:
			return {
				...state,
				[type]: payload,
			};
		default:
			return state;
	}
};
